import { FC } from 'react';
import { ISpecialDatesPopup } from './specialDatesSettings.popup';
import { FormProvider, useForm } from 'react-hook-form';
import {
  FieldsRow,
  FormDatePicker,
  FormTextField,
} from '../../../../../../../shared/components/form';
import { useTranslation } from 'react-i18next';
import { Button, Stack } from '@mui/material';
import { useBeforeClosePopup } from '../../../../../../../shared/components/popup/hooks/useBeforeClosePopup';
import { PopupService } from '../../../../../../../shared/components/popup/services/popup.service';
import { dictionaryState } from '../../../../../../../shared/components/dictionary/states/dictionary.state';
import { format } from 'date-fns';

export const Content: FC<IContent> = ({ data, stream }) => {
  const { id, date, replacingDate } = data;
  const defaultValues: IFormData = {
    ...data,
    date: date ? new Date(date) : null,
    replacingDate: replacingDate ? new Date(replacingDate) : null,
  };
  const formMethods = useForm<IFormData>({
    mode: 'onChange',
    defaultValues,
  });
  const { t } = useTranslation();
  const {
    handleSubmit,
    formState: { isDirty, errors },
  } = formMethods;
  const submitHandler = (v: IFormData) => {
    if (isDirty) {
      const values = {
        ...v,
        date: v.date ? format(v.date, 'yyyy-MM-dd') : null,
        replacingDate: v.replacingDate ? format(v.replacingDate, 'yyyy-MM-dd') : null,
      };
      // Creating a new record
      if (!id) dictionaryState.pub.addRow(values);
      dictionaryState.pub.updateCell(
        {
          id: id || '',
          field: 'virtualField',
          value: values,
        },
        true,
      );
    }
    stream.emit('close');
  };

  useBeforeClosePopup({
    stream,
    isDirty,
  });

  return (
    <FormProvider {...formMethods}>
      <FieldsRow>
        <FormDatePicker
          name='date'
          fieldProps={{ label: t('common.date') }}
          controllerProps={{
            rules: { validate: (value) => (!value ? 'common.not_empty' : undefined) },
          }}
          error={Boolean(errors['date'])}
          helperText={errors['date'] ? t(String(errors['date'].message)) : ''}
          navigation={false}
        />
        <FormDatePicker
          name='replacingDate'
          fieldProps={{ label: t('settings.replacing_date') }}
          controllerProps={{
            rules: { validate: (value) => (!value ? 'common.not_empty' : undefined) },
          }}
          error={Boolean(errors['replacingDate'])}
          helperText={errors['replacingDate'] ? t(String(errors['replacingDate'].message)) : ''}
          navigation={false}
        />
      </FieldsRow>
      <FieldsRow>
        <FormTextField name='description' label={t('common.description')} width='100%' />
      </FieldsRow>
      <Stack
        direction='row'
        sx={{
          justifyContent: 'end',
          mt: 3,
        }}
      >
        <Button variant='contained' color='primary' onClick={handleSubmit(submitHandler)}>
          {t('common.save')}
        </Button>
      </Stack>
    </FormProvider>
  );
};

interface IContent {
  data: ISpecialDatesPopup['values'];
  stream: PopupService<ISpecialDatesPopup>;
}
interface IFormData extends Omit<ISpecialDatesPopup['values'], 'id' | 'date' | 'replacingDate'> {
  date: Date | null;
  replacingDate: Date | null;
}
